import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { wizard } from 'helpers/decorators'
import { Title, Note, Button, FormDebug } from 'components/misc'
import { Parent as ParentForm } from 'components/forms'
import { apiConfiguration } from 'helpers/decorators/api'
import validate from './parent.validate'

@apiConfiguration()
@wizard({
  form: 'nextLevelRegistration',
  multipage: true,
  validate,
  destroyOnUnmount: false
})
class Parent extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    values: PropTypes.object,
    onGetConfigurationValue: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired
  }

  render() {
    const { handleSubmit, values, onSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>

        <Title h1>
          <FormattedMessage id='moduleTitle.profile_guardian_consent' defaultMessage='Profile/Guardian Consent' />
        </Title>

        <Note lighter margin='0 0 35px 0'>
          <FormattedMessage
            id='label.because_your_age_is_under_18'
            defaultMessage='Because your age is under 18 we need to consent from your parent/guardian.'
          />
        </Note>

        <ParentForm
          values={values}
          onGetConfigurationValue={this.props.onGetConfigurationValue}
          configuration={this.props.configuration}/>

        <FormDebug {...this.props} />

        <Button>
          <FormattedMessage id='button.continue' defaultMessage='Continue' />
        </Button>
      </form>
    )
  }
}

export default Parent
